import React from 'react'

import { Box, Text } from 'stardust'

import colors from '~/ui-components/tokens/colors'

// Small pill marking a document authored with the new (tiptap) Beta editor, so
// new-format documents read as distinct from legacy Slate ones wherever a
// DocumentCard renders (the Beta Documents grid and the classic Documents list).
const BetaBadge = () => (
  <Box bg={colors.pulsarPurple11} borderRadius="40px" p="3px 8px" width="max-content" data-qa="beta-badge">
    <Text.span bold caps color={colors.pulsarPurple10} fontSize={0} lineHeight="15px" letterSpacing="0.4px">
      Beta
    </Text.span>
  </Box>
)

BetaBadge.displayName = 'BetaBadge'

export default BetaBadge
